import Dialog from '@/generated/classes/Dialog';

export interface AdminEditDialog {
  (dialog: Dialog): boolean;
}

export interface EditDialog {
  (dialog: Dialog): Promise<boolean>;
}

export class Dialogs {

  private static editedDialog: Dialog;
  private static adminEditDialog: AdminEditDialog;

  public static setAdminEditDialog (adminEditDialog: AdminEditDialog) {
    Dialogs.adminEditDialog = adminEditDialog;
  }

  public static getEdited (): Dialog {
    return Dialogs.editedDialog;
  }

  public static editDialog (dialog: Dialog): Promise<boolean> {
    return new Promise((resolve) => {
      Dialog.get(dialog.id).then((res) => {
        Dialogs.editedDialog = res;
        resolve(Dialogs.adminEditDialog(dialog));
      });
    });
  }
}



